import type { FootballEventStatus } from '@pff-consumer/schema'

export const isUpcomingEvent = (eventStatus?: FootballEventStatus) => {
  if (!eventStatus) return false
  return ['Suspended', 'Scheduled', 'Postponed', 'Delayed'].includes(eventStatus)
}

export const isLiveEvent = (eventStatus?: FootballEventStatus) => eventStatus === 'InProgress'

export const isEventComplete = (eventStatus?: FootballEventStatus) =>
  eventStatus === 'Final' || eventStatus === 'F/OT' || eventStatus === 'Canceled' || eventStatus === 'Forfeit'
